import React from 'react';
import { func, arrayOf, string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BadgeFilters } from './containers';
import './ToggleFiltersPanelButton.scss';

export default function ToggleFiltersPanelButton({ onClick, excludedFilters }) {
    return (
        <button
            className="toggle-filters-panel-button"
            data-button="toggleCollapsePanel"
            data-qa="toggleMobileFilters"
            onClick={onClick}
        >
            <div className="toggle-filters-panel-button__content">
                <FormattedMessage
                    id="listing.filters.openFiltersPanelButton"
                    description="Label of the button used to toggle mobile filters panel"
                    defaultMessage="FILTERS"
                />
                <BadgeFilters excludedFilters={excludedFilters} />
            </div>
        </button>
    );
}

ToggleFiltersPanelButton.propTypes = {
    onClick: func.isRequired,
    excludedFilters: arrayOf(string),
};

ToggleFiltersPanelButton.defaultProps = {
    excludedFilters: [],
};
